import {
  AUDIT_LOGS_INDEX_REQUESTED,
  AUDIT_LOGS_INDEX_SUCCESS,
  AUDIT_LOGS_INDEX_FAILURE,
} from '../types';

const INITIAL_STATE = {
  auditLogs: [],
  isFetching: false,
  isFetchingMore: false,
  lastPage: false,
  continuationToken: null,
  status: 'waiting',
  errors: null
};

const auditLogs = (state = INITIAL_STATE, action) => {
  switch(action.type) {
    case AUDIT_LOGS_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: !action.append,
        isFetchingMore: action.append,
        status: 'requesting',
        errors: null
      });

    case AUDIT_LOGS_INDEX_SUCCESS: {
      const newLogs = action.payload.audit_logs || [];

      return Object.assign({}, state, {
        auditLogs: action.append ? [...state.auditLogs, ...newLogs] : newLogs,
        isFetching: false,
        isFetchingMore: false,
        lastPage: action.payload.last_page,
        continuationToken: action.payload.continuation_token,
        status: 'success',
        errors: null
      });
    }

    case AUDIT_LOGS_INDEX_FAILURE:
      return Object.assign({}, state, {
        isFetching: false,
        isFetchingMore: false,
        status: 'error',
        errors: action.error
      });

    default:
      return state;
  }
};

export default auditLogs;
